export enum ConstructionCosts {
    LESS_THAN_10M = 'less_than_10m',
    BETWEEN_10M_AND_25M = 'between_10m_and_25m',
    BETWEEN_25M_AND_50M = 'between_25m_and_50m',
    GREATER_THAN_50M = 'greater_than_50m'
}
